import { render } from "./TownsModal.vue?vue&type=template&id=af1285e4&scoped=true&ts=true"
import script from "./TownsModal.vue?vue&type=script&lang=ts"
export * from "./TownsModal.vue?vue&type=script&lang=ts"

import "./TownsModal.vue?vue&type=style&index=0&id=af1285e4&scoped=true&lang=css"

import exportComponent from "/home/bese/Documents/partybeast/party-beast-prototype/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af1285e4"]])

export default __exports__